// Mapping des 31 critères de l'examen blanc → étapes de la progression 23 étapes
// (utile pour rediriger l'élève vers les étapes concrètes à retravailler).

export const CRITERE_ETAPES_MAP = {
  1:  ['M1', 'P1'],                 // Installation & vérifs
  2:  ['M4', 'M11'],                // Démarrage, arrêt, côte
  3:  ['M2', 'M3', 'M5'],           // Commandes, volant, vitesses
  4:  ['M3'],                       // Trajectoire
  5:  ['M5', 'M6', 'M10'],          // Adaptation vitesse
  6:  ['O1', 'O3'],                 // Distances de sécurité
  7:  ['O1', 'O2', 'O3'],           // Regard, prise d'info
  8:  ['O3', 'O4'],                 // Angles morts
  9:  ['M13'],                      // Signalisation
  10: ['M13'],                      // Marquages
  11: ['M13'],                      // Feux tricolores
  12: ['M13', 'O6'],                // Intersections simples
  13: ['M13', 'O6'],                // STOP / cédez
  14: ['O5'],                       // Giratoires
  15: ['O3', 'O4'],                 // Changements de direction
  16: ['O3', 'O4', 'O7'],           // Dépassements
  17: ['O4', 'O7'],                 // Partage route
  18: ['O4'],                       // Passages piétons
  19: ['O6'],                       // Agglomération
  20: ['O7'],                       // Hors agglomération
  21: ['O7'],                       // Chaussées plusieurs voies
  22: ['O7', 'P2'],                 // Imprévus / dangers
  23: ['M8', 'M9'],                 // Manœuvres imposées
  24: ['M12', 'O5'],                // Commandes en situation complexe
  25: ['P2', 'P3'],                 // Autonomie
  26: ['P3'],                       // Éco-conduite
  27: ['O4', 'P3'],                 // Respect usagers
  28: ['P3'],                       // Stress
  29: ['P2', 'P3'],                 // Sécurité décisions
  30: ['P3'],                       // Aptitude conduire seul
  31: ['P2', 'P3'],                 // Respect global du Code
};

export function getEtapesForCritere(n) {
  return CRITERE_ETAPES_MAP[n] || [];
}
